import { forwardRef } from 'react';
import { classNames } from '~/utils/classNames';

interface MenuItemProps {
  className?: string;
  icon?: string;
  text?: string;
  active: boolean;
  comingSoon?: boolean;
  onClick: () => void;
}

export const SettingsMenuItem = forwardRef<HTMLButtonElement, MenuItemProps>(
  ({ icon, text, active, comingSoon, onClick, className, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        className={classNames(
          'w-full flex items-center shrink-0 justify-center md:justify-start gap-3 h-[33px] px-2.5 rounded-md text-sm font-medium',
          {
            'text-bolt-ds-surfaceTwo opacity-60': comingSoon,
            'bg-bolt-ds-surfaceHighlight text-bolt-ds-textPrimary': active,
            'bg-transparent hover:bg-bolt-ds-surfaceHighlight text-bolt-ds-textTertiary/60': !active,
          },
          className,
        )}
        onClick={onClick}
        {...rest}
      >
        <span
          className={classNames(icon, 'size-4 shrink-0', {
            'text-bolt-ds-iconPrimary': active,
            'text-bolt-ds-iconSecondary/50': !active,
          })}
        />
        <span className="truncate hidden md:block">{text}</span>
      </button>
    );
  },
);

SettingsMenuItem.displayName = 'SettingsMenuItem';
